import API from '../utils/API'
import { Modal } from './modal'

class Bookmark {
  constructor(el) {
    this.button = el
    this.postID = this.button.dataset.id
    this.isBookmarked = this.button.classList.contains('bookmark--bookmarked')

    this.handleClick = this.handleClick.bind(this)
    this.init()
  }

  /**
   * Shows A PopUp to inform the user that the item has been bookmarked
   */
  openPopUp() {
    const modalEl = document.createElement('div')
    modalEl.className = 'modal modal--thank-you'
    modalEl.innerHTML = `
      <div class="modal__dialog bg-white">
        <button type="button" class="modal__close">
          <svg class="icon" width="25" height="25" fill="#000">
            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#times"></use>
          </svg>
        </button>
        <div class="modal__body">
          <div class="modal__message">
            <div class="modal__message__headline align-center headline headline--lg text-black">
              Bookmarked
            </div>
            <div class="modal__message__copy align-center text text--md text-black mt-2">
              You can find bookmarked content in your account.
            </div>
          </div>
        </div>
      </div>
    `
    document.body.appendChild(modalEl)
    const modal = new Modal(modalEl, true)
    modal.open({ target: this.button })
  }

  /**
   * Triggers when bookmarking action (add/remove) was successfull
   */
  success() {
    this.isBookmarked = !this.isBookmarked
    if (this.isBookmarked) {
      this.button.classList.add('bookmark--bookmarked')
      this.openPopUp()
      this.button.dispatchEvent(
        new CustomEvent('bookmark-added', {
          bubbles: true,
        }),
      )
    } else {
      this.button.classList.remove('bookmark--bookmarked')
      this.button.dispatchEvent(
        new CustomEvent('bookmark-removed', {
          bubbles: true,
        }),
      )
    }
    this.propagate()
  }

  /**
   * Propagates the bookmarked state to other elements
   */
  propagate() {
    const buttons = document.querySelectorAll(`[data-id="${this.postID}"]`)
    if (buttons) {
      buttons.forEach(button => {
        if (button !== this.button) {
          if (this.isBookmarked) {
            button.classList.add('bookmark--bookmarked')
          } else {
            button.classList.remove('bookmark--bookmarked')
          }
        }
      })
    }
  }

  /**
   * Handles Bookmark button click
   *
   * @param {Event} e
   */
  async handleClick(e) {
    e.preventDefault()
    const { api } = window.sapiens
    const endpoint = `${api}/bookmark/${this.isBookmarked ? 'remove' : 'add'}`

    this.button.setAttribute('disabled', 'disabled')
    this.button.classList.add('bookmark--fetching')

    const response = await API.post(endpoint, {
      id: Number(this.postID),
    })

    const { error } = response

    if (!error) {
      this.success()
    }

    this.button.removeAttribute('disabled')
    this.button.classList.remove('bookmark--fetching')
    e.stopPropagation()
  }

  init() {
    this.button.addEventListener('click', this.handleClick)
  }
}

const bookmarkInit = {
  init() {
    const wrapperEl = document.querySelectorAll('.bookmark')
    Array.from(wrapperEl).forEach(btn => new Bookmark(btn))
  },
}

export default bookmarkInit
